module.exports = function($scope) {
  
  var vm = this;
  
  function init() {
    $scope.message = $scope.ngDialogData.message;
    $scope.okOnly = $scope.ngDialogData.okOnly;
    $scope.okLabel = $scope.ngDialogData.okLabel || "Ok";
    $scope.cancelLabel = $scope.ngDialogData.cancelLabel || "Cancel";
  }
  
  $scope.ok = function() {
    $scope.closeThisDialog({action:"ok"})
  }
  
  $scope.cancel = function() {
    $scope.closeThisDialog({action:"cancel"})
  }
  
  init();
}
